import script from "./CenterView.vue?vue&type=script&setup=true&lang=js"
export * from "./CenterView.vue?vue&type=script&setup=true&lang=js"

import "./CenterView.vue?vue&type=style&index=0&id=4a79aa16&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a79aa16"]])

export default __exports__